<script setup lang="ts">
import { slideToggle } from '@/composables/slideToggle.js'
import { useAppOptionStore } from '@/stores/app-option'
import { RouterLink } from 'vue-router'

const appOption = useAppOptionStore()
const notificationData = [
  {
    icon: 'fa fa-receipt fa-lg fa-fw text-success',
    title: 'Your store has a new order for 2 items totaling $1,299.00',
    time: 'just now',
  },
  {
    icon: 'far fa-user-circle fa-lg fa-fw text-body text-opacity-25',
    title: '3 new customer account is created',
    time: '2 minutes ago',
  },
  {
    img: '/assets/img/icon/android.svg',
    title: 'Your android application has been approved',
    time: '5 minutes ago',
  },
  {
    img: '/assets/img/icon/paypal.svg',
    title: 'Paypal payment method has been enabled for your store',
    time: '10 minutes ago',
  },
]

function toggleAppSidebarMinify() {
  if (!(appOption.appTopNav && appOption.appSidebarHide)) {
    appOption.appSidebarMinified = !appOption.appSidebarMinified
  }
}
function toggleAppSidebarMobileToggled() {
  if (appOption.appTopNav && appOption.appSidebarHide) {
    slideToggle(document.querySelector('.app-top-nav'))
    window.scrollTo(0, 0)
  } else {
    appOption.appSidebarMobileToggled = !appOption.appSidebarMobileToggled
  }
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function toggleAppHeaderSearch(_event: Event) {
  // Reserved for future search toggle functionality
  // appOption.appHeaderSearchToggled = !appOption.appHeaderSearchToggled;
}
function checkForm(event: Event) {
  event.preventDefault()
  // TODO: Implement search navigation
  // router.push({ path: '/extra/search' })
}
</script>
<template>
  <div id="header" class="app-header">
    <!-- BEGIN mobile-toggler -->
    <div class="mobile-toggler">
      <button type="button" class="menu-toggler" @click="toggleAppSidebarMobileToggled">
        <span class="bar"></span>
        <span class="bar"></span>
      </button>
    </div>
    <!-- END mobile-toggler -->

    <!-- BEGIN brand -->
    <div class="brand">
      <div class="desktop-toggler">
        <button type="button" class="menu-toggler" @click="toggleAppSidebarMinify">
          <span class="bar"></span>
          <span class="bar"></span>
        </button>
      </div>

      <RouterLink to="/" class="brand-logo">
        <img src="/logo.png" class="invert-dark" alt="" height="20" />
      </RouterLink>
    </div>
    <!-- END brand -->

    <!-- BEGIN menu -->
    <div class="menu">
      <form class="menu-search" name="header_search_form" @submit="checkForm">
        <div class="menu-search-icon"><i class="fa fa-search"></i></div>
        <div class="menu-search-input">
          <input type="text" class="form-control" placeholder="Search menu..." />
        </div>
      </form>
      <div class="menu-item dropdown">
        <a href="#" data-bs-toggle="dropdown" data-display="static" class="menu-link">
          <div class="menu-icon"><i class="fa fa-bell nav-icon"></i></div>
          <div class="menu-label">{{ notificationData.length }}</div>
        </a>
        <div class="dropdown-menu dropdown-menu-end dropdown-notification">
          <h6 class="dropdown-header text-body-emphasis mb-1">Notifications</h6>
          <template v-if="notificationData && notificationData.length > 0">
            <a
              v-for="(notification, index) in notificationData"
              :key="index"
              href="#"
              class="dropdown-notification-item"
            >
              <div class="dropdown-notification-icon">
                <i v-if="notification.icon" :class="notification.icon"></i>
                <img v-if="notification.img" :src="notification.img" width="26" />
              </div>
              <div class="dropdown-notification-info">
                <div class="title">{{ notification.title }}</div>
                <div class="time">{{ notification.time }}</div>
              </div>
              <div class="dropdown-notification-arrow">
                <i class="fa fa-chevron-right"></i>
              </div>
            </a>
          </template>
          <template v-else>
            <div class="dropdown-notification-item">No record found</div>
          </template>
          <div class="p-2 text-center mb-n1">
            <a href="#" class="text-body-emphasis text-opacity-50 text-decoration-none">See all</a>
          </div>
        </div>
      </div>
      <div class="menu-item dropdown">
        <a href="#" data-bs-toggle="dropdown" data-display="static" class="menu-link">
          <div class="menu-img online">
            <img src="/pholder.jpeg" alt="" class="ms-100 mh-100 rounded-circle" />
          </div>
          <div class="menu-text">User</div>
        </a>
        <div class="dropdown-menu dropdown-menu-end me-lg-3">
          <RouterLink to="/profile" class="dropdown-item d-flex align-items-center"
            >Edit Profile <i class="fa fa-user-circle fa-fw ms-auto text-gray-400 fs-16px"></i
          ></RouterLink>
          <RouterLink to="/email/inbox" class="dropdown-item d-flex align-items-center"
            >Inbox <i class="fa fa-envelope fa-fw ms-auto text-gray-400 fs-16px"></i
          ></RouterLink>
          <RouterLink to="/calendar" class="dropdown-item d-flex align-items-center"
            >Calendar <i class="fa fa-calendar-alt fa-fw ms-auto text-gray-400 fs-16px"></i
          ></RouterLink>
          <RouterLink to="/settings" class="dropdown-item d-flex align-items-center"
            >Setting <i class="fa fa-wrench fa-fw ms-auto text-gray-400 fs-16px"></i
          ></RouterLink>
          <div class="dropdown-divider"></div>
          <RouterLink to="/page/login" class="dropdown-item d-flex align-items-center"
            >Log Out <i class="fa fa-toggle-off fa-fw ms-auto text-gray-400 fs-16px"></i
          ></RouterLink>
        </div>
      </div>
    </div>
    <!-- END menu -->
  </div>
</template>
